<template>
  <div class="wave">
    <svg class="w-500 md:w-full" preserveAspectRatio="none" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="`0 0 700 300`" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0">
          <stop stop-color="#4cbdd5" offset="0%" />
          <stop stop-color="#236f99" offset="100%" />
        </linearGradient>
      </defs>
      <path
        style="transform:translate(0, 0px); opacity:1"
        fill="url(#sw-gradient-0)"
        d="M0,256L20,266.7C40,277,80,299,120,282.7C160,267,200,213,240,202.7C280,192,320,224,360,234.7C400,245,440,235,480,245.3C520,256,560,288,600,282.7C640,277,680,235,720,181.3C760,128,800,64,840,85.3C880,107,920,213,960,256C1000,299,1040,277,1080,261.3C1120,245,1160,235,1200,229.3C1240,224,1280,224,1320,240C1360,256,1400,288,1420,304L1440,320L1440,0L1420,0C1400,0,1360,0,1320,0C1280,0,1240,0,1200,0C1160,0,1120,0,1080,0C1040,0,1000,0,960,0C920,0,880,0,840,0C800,0,760,0,720,0C680,0,640,0,600,0C560,0,520,0,480,0C440,0,400,0,360,0C320,0,280,0,240,0C200,0,160,0,120,0C80,0,40,0,20,0L0,0Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  computed: {},
};
</script>

<style scoped>
svg {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
</style>